import type { DisplayPublic } from '../api';
import { AdOnlyChannel } from './AdOnlyChannel';
import { AdReelChannel } from './AdReelChannel';
import { AuxClockChannel } from './AuxClockChannel';
import { MenuChannel } from './MenuChannel';
import { ScoreboardChannel } from './ScoreboardChannel';
import { SignageChannel } from './SignageChannel';
import { StandingsChannel } from './StandingsChannel';
import { StatsBoardChannel } from './StatsBoardChannel';
import { StreamOverlayChannel } from './StreamOverlayChannel';

export type ChannelProps = {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
};

export type ChannelComponent = (props: ChannelProps) => JSX.Element;

const REGISTRY: Record<string, ChannelComponent> = {
  SCOREBOARD: ScoreboardChannel,
  AUX_CLOCK: AuxClockChannel,
  STANDINGS: StandingsChannel,
  STREAM_OVERLAY: StreamOverlayChannel,
  MENU: MenuChannel,
  AD_REEL: AdReelChannel,
  SIGNAGE: SignageChannel,
  STATS_BOARD: StatsBoardChannel,
  AD_ONLY: AdOnlyChannel,
};

export function pickChannel(channelType: string): ChannelComponent {
  return REGISTRY[channelType] ?? ScoreboardChannel;
}
